/**
 * The fixed sport set the research surfaces (StreamRift's Eye, G3's Game
 * Viewer and Realtime tabs) read from the store — ONE constant so the feed
 * declaration and the reads cannot drift (feed-filters-per-view).
 */
import type { Sport } from '@/views/ValueDashboard/types';

export const LIVE_RESEARCH_SPORTS: readonly Sport[] = ['nba', 'nhl', 'mlb', 'cbb', 'atp', 'wta'];
